module.exports = __webpack_public_path__ + "img/neglected-active.c67b874.svg";